import { getAudioCtx } from '../../../utils/audioCore';

/* Agenda — monthly checklist tracker. 100% localStorage (zero cloud). */

const KEY = 'bliss_agenda_v1';

export const GOLD = '#D4AF37';
export const GOLD_HI = '#F5D97A';
export const INK = '#07060B';

/* The 8 Bliss pillars — same animal icons + accents used across the app. */
export const CATS = {
  fashion: { icon: '/icons/leopard_v2.png',    color: '#D4AF37', label: 'Fashion' },
  food:    { icon: '/icons/gazelle.png',       color: '#E8CE94', label: 'Food' },
  explore: { icon: '/icons/falcon_v2.png',     color: '#4A85E8', label: 'Explore' },
  souls:   { icon: '/icons/phoenix_v2.png',    color: '#FF4A6A', label: 'Soul' },
  sporty:  { icon: '/icons/gorilla_v2.png',    color: '#10B981', label: 'Sport' },
  success: { icon: '/icons/stallion_v2.png',   color: '#E5C44D', label: 'Success' },
  legacy:  { icon: '/icons/lion_legacy.png',   color: '#B08CFF', label: 'Legacy' },
  art:     { icon: '/icons/crystal_crane.png', color: '#5BC0F0', label: 'Art' },
};
export const CAT_IDS = Object.keys(CATS);

export const SUGGESTIONS = [
  ['Wake up at 05:00', 'success'], ['Gym', 'sporty'], ['Reading / Learning', 'legacy'],
  ['Day Planning', 'success'], ['Deep Work', 'fashion'], ['No Junk Food', 'food'],
  ['Social Media Detox', 'souls'], ['Goal Journaling', 'art'], ['Cold Shower', 'sporty'],
  ['10k Steps', 'explore'], ['Plan Tomorrow', 'legacy'],
];

const blank = () => ({ items: [], checks: {}, mood: {}, sleep: {} });

export const loadAgenda = () => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? { ...blank(), ...JSON.parse(raw) } : blank();
  } catch (_) { return blank(); }
};

export const saveAgenda = (s) => {
  try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (_) { /* quota */ }
};

const pad = (n) => String(n).padStart(2, '0');
export const dayKey = (y, m, d) => `${y}-${pad(m + 1)}-${pad(d)}`;
export const todayKey = () => { const t = new Date(); return dayKey(t.getFullYear(), t.getMonth(), t.getDate()); };

export const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
  'August', 'September', 'October', 'November', 'December'];
const DOW = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

/* Calendar weeks start on Sunday (Week 1 = day 1 → first Saturday). */
export const monthDays = (y, m) => {
  const count = new Date(y, m + 1, 0).getDate();
  const firstDow = new Date(y, m, 1).getDay();
  return Array.from({ length: count }, (_, i) => {
    const d = i + 1;
    const dow = (firstDow + i) % 7;
    return { d, dow, dowLabel: DOW[dow], key: dayKey(y, m, d), week: Math.floor((i + firstDow) / 7) };
  });
};

export const computeStats = (state, days) => {
  const { items, checks } = state;
  const goal = days.length;
  const perItem = items.map((it) => {
    const actual = days.reduce((n, day) => n + (checks[day.key]?.[it.id] ? 1 : 0), 0);
    return { item: it, goal, actual, left: goal - actual, pct: goal ? actual / goal : 0 };
  });
  const daily = days.map((day) => {
    const done = items.reduce((n, it) => n + (checks[day.key]?.[it.id] ? 1 : 0), 0);
    return { ...day, pct: items.length ? done / items.length : 0 };
  });
  const weekCount = days.length ? days[days.length - 1].week + 1 : 0;
  const weekly = Array.from({ length: weekCount }, (_, w) => {
    const wd = daily.filter((d) => d.week === w);
    const pct = wd.length ? wd.reduce((s, d) => s + d.pct, 0) / wd.length : 0;
    return { week: w, pct, from: wd[0]?.d, to: wd[wd.length - 1]?.d };
  });
  const totalGoal = goal * items.length;
  const completed = perItem.reduce((s, p) => s + p.actual, 0);
  return { perItem, daily, weekly, totalGoal, completed, left: totalGoal - completed };
};

export const pctLabel = (p) => `${Math.round(p * 100)}%`;

/* Crisp check / uncheck tick on the shared audio context. */
export const tickSound = (on) => {
  const ctx = getAudioCtx();
  if (!ctx) return;
  const t = ctx.currentTime;
  const o = ctx.createOscillator();
  const g = ctx.createGain();
  o.type = 'sine';
  o.frequency.setValueAtTime(on ? 1320 : 620, t);
  o.frequency.exponentialRampToValueAtTime(on ? 1860 : 420, t + 0.06);
  g.gain.setValueAtTime(0.0001, t);
  g.gain.exponentialRampToValueAtTime(on ? 0.26 : 0.16, t + 0.004);
  g.gain.exponentialRampToValueAtTime(0.0001, t + 0.13);
  o.connect(g).connect(ctx.destination);
  o.start(t);
  o.stop(t + 0.15);
};
